<template>
  <div>
    <table width="100%" class="table">
      <thead>
        <tr>
          <!--          <th>{{ role === 'admin' ? '任务ID' : '序号' }}</th>-->
          <th>{{ '任务ID' }}</th>
          <th>任务名</th>
          <!--          <th v-if="role === 'admin'">-->
          <!--            <select-->
          <!--              id="customer-select"-->
          <!--              class="clickable"-->
          <!--              v-model="customerId"-->
          <!--              @change="$emit('customerChange', customerId)"-->
          <!--            >-->
          <!--              <option value="">创建人</option>-->
          <!--              <option v-for="c of customerList" :value="c.userId" :key="`customer${c.userId}`">{{ c.userName }}</option>-->
          <!--            </select>-->
          <!--          </th>-->
          <th v-if="role === 'admin' || role === 'customer'">创建时间</th>
          <!-- <th v-if="role === 'admin' || role === 'customer'">行业</th> -->
          <!-- <th>标注方式</th>-->
          <th v-if="role === 'customer' || role === 'admin'">描述</th>
          <th v-if="role === 'admin' || role === 'customer'">图片数</th>
          <th v-if="role === 'admin' || role === 'customer'">无框图片数</th>
          <th v-if="role === 'customer'">任务状态</th>
          <th v-if="role === 'admin'">
            <select
              id="status-select"
              class="clickable"
              v-model="taskStatus"
              @change="$emit('statusChange', taskStatus)"
            >
              <option value="0">任务状态</option>
              <option
                v-for="(ts, index) of taskStatusFilterMap"
                :value="Object.keys(taskStatusFilterMap)[index - 1]"
                :key="`status${index}`"
                >{{ ts }}</option
              >
            </select>
          </th>
          <th style="width: 140px;">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="task of taskList" :key="'task' + task.id">
          <td>{{ task.id }}</td>
          <td style="max-width: 180px;">{{ task.taskName }}</td>
          <!--          <td v-if="role === 'admin'">{{ task.createName }}</td>-->
          <td v-if="role === 'admin' || role === 'customer'">
            {{ reformatTime(task.createAt) }}
          </td>
          <!-- <td v-if="role === 'admin' || role === 'customer'">{{ task.industryName }}</td> -->
          <!-- <td>{{ task.taskTypeName }}</td>-->
          <td v-if="role === 'customer' || role === 'admin'">
            <span
              v-if="task.desc"
              class="class-info"
              style="text-overflow:ellipsis;width:116px;overflow:hidden;white-space:nowrap;display: inline-block;padding: 5px;"
              >{{ task.desc }}</span
            >
            <div
              class="class-info"
              v-if="task.desc"
              style="max-width: 308px;word-wrap:break-word;padding: 12px;color:#595959;white-space: pre-line; text-align: left"
            >
              {{ task.desc }}
            </div>
          </td>
          <td v-if="role === 'admin' || role === 'customer'">{{ task.imageCount ? task.imageCount : 0 }}</td>
          <td v-if="role === 'admin' || role === 'customer'">
            {{ task.taskStatus === 5 ? noAnnoImageMap[task.id] || 0 : '-' }}
          </td>
          <td v-if="role === 'admin' || role === 'customer'">
            <i
              style="width:6px;height:6px;border-radius:50%;display: inline-block;vertical-align: middle;margin-right: 4px;"
              :style="{ backgroundColor: getTaskStatusColor(taskStatusMap[task.taskStatus]) }"
            ></i>
            {{ taskStatusMap[task.taskStatus] }}
          </td>
          <td>
            <a
              :class="btnStatus(task) > 0 ? '' : 'disable'"
              @click="toImageDetail(btnStatus(task) > 0, task)"
              v-if="role !== 'customer' && role !== 'admin'"
              >{{ role === 'annotator' ? '标注' : '审核' }}</a
            >
            <!--            <a-->
            <!--              :class="btnStatus(task) === -2 ? '' : 'disable'"-->
            <!--              @click="toExam(btnStatus(task) === -2, task)"-->
            <!--              v-if="role === 'annotator'"-->
            <!--              >测试</a-->
            <!--            >-->
            <span
              @click="toTaskDetail(task.id)"
              v-if="role === 'admin' || role === 'customer'"
              style="color: #5d89c0;cursor: pointer;"
              >详情</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import { taskStatusMap, taskStatusFilterMap, roleMapReverse } from '@/config';
import moment from 'moment';

export default {
  name: 'tasklist',
  data() {
    return {
      role: '',
      taskStatusMap: [],
      taskStatusFilterMap: [],
      customerId: '',
      taskStatus: 0,
      finishedExamIds: [],
      examList: [],
      examTypeMap: {
        default: '3,4',
        annotator: '1',
        approver: '2',
      },
      needPractice: 1,
      noAnnoImageMap: {},
    };
  },
  props: ['taskList', 'customerList', 'itemTotal', 'pageIndex', 'pageSize'],
  computed: {
    reformatTime: function() {
      return function(time) {
        return moment(time).format('YYYY/MM/DD HH:mm:ss');
      };
    },
  },
  mounted: function() {
    this.taskStatusMap = taskStatusMap;
    this.taskStatusFilterMap = taskStatusFilterMap;
    this.role = this.$store.state.role;
    this.$store.commit('setKeepAlive', ['task']);
    if (this.role !== 'customer')
      api.getFinishedExamIds().then(res => {
        this.finishedExamIds = res.data;
      });
    if (this.role === 'annotator') {
      this.needPractice = window.localStorage.getItem('needPractice')
        ? parseInt(window.localStorage.getItem('needPractice'))
        : 1;
      this.getExamAnno();
    }
    // 监听websocket返回的无框图统计信息
    this.sockets.subscribe('noAnnoImageStatisticInfo', data => {
      data.forEach(item => {
        this.noAnnoImageMap[item.taskId] = item.cnt;
      });
      this.$message.success('无框图信息已更新');
      this.$forceUpdate();
    });
  },
  beforeDestroy: function() {
    this.sockets.unsubscribe('noAnnoImageStatisticInfo');
  },
  methods: {
    btnStatus(task) {
      if (task.status === 1) return -1;
      // if (this.role === 'annotator') {
      //   if (task.examIds && task.examIds.length > 0) {
      //     if (task.examIds.some(v => !this.finishedExamIds.includes(v))) {
      //       return -2;
      //     }
      //   }
      // }
      // 考试题不再混合在任务中，标注员在进行标注前必须完成所有练习题
      if (this.role === 'annotator' && this.examList.length) return -1;
      return roleMapReverse[this.role] - task.taskStatus;
      // if (task.taskStatus !== 2) return -1;
      // if (this.role !== 'annotator') return 1;
      // if (!task.examIds || task.examIds.length === 0) return 2;
      // if (task.examIds.every(v => this.finishedExamIds.includes(v))) return 3;
      // return -2;
    },
    toTaskDetail(taskId) {
      // this.$store.commit('addKeepAlive', 'taskdetail');
      this.$router.push(`/task/${taskId}`);
    },
    getTaskStatusColor: function(status) {
      if (['标注中', '一审中', '二审中'].includes(status)) return '#5d89c0';
      else if (status === '已完成') return '#70c05d';
      else return '#bbbbbb';
    },
    toImageDetail(able, task) {
      if (!able) return;
      if (this.role === 'annotator') this.$router.push({ path: `/task/${task.id}/image/annotate` });
      else if (this.role === 'approver' || this.role === 'approverTwo')
        this.$router.push({ path: `/task/${task.id}/image/approve` });
    },
    toExam(able, task) {
      if (!able) return;
      this.$router.push({ path: `/exam/${task.examIds[0]}/annotate` });
    },
    classInfoText(task) {
      if (task && task.classifications && task.classifications[0])
        return task.classifications[0].classes.map(item => item.className).join(',');
      else return '';
    },
    getExamAnno() {
      api
        .getExamAnno(this.examTypeMap[this.role] || '1')
        .then(res => {
          this.examList = this.needPractice ? res.data : [];
        })
        .catch(err => window.console.log(err));
    },
  },
};
</script>

<style scoped>
.disable {
  color: #bbbbbb;
}
a {
  color: #5d89c0;
  text-decoration: none;
  display: inline-block;
  margin: 2px 5px;
  cursor: pointer;
}
p {
  display: inline-block;
  margin: 0px 6px;
  vertical-align: top;
}
section {
  display: inline-block;
  width: max-content;
  vertical-align: top;
  padding: 0px 10px;
  color: #595959;
}
section span {
  display: block;
  padding-bottom: 5px;
}
select {
  border: none;
  font-size: 14px;
  font-weight: bold;
  appearance: none;
  outline: none;
}
span.class-info {
  position: relative;
  text-decoration: underline;
  color: #5d89c0;
}
span.class-info:hover + div.class-info {
  visibility: visible;
}
div.class-info {
  background-color: #ffffff;
  padding: 16px 2px;
  width: max-content;
  position: absolute;
  visibility: hidden;
  z-index: 999;
  border: 1px solid #eeeeee;
  color: #5d89c0;
  box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 1);
  border-radius: 0px 0px 5px 5px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
}
table th,
table td {
  padding-left: 24px;
  text-align: center;
  word-break: break-all;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
</style>
